export const GoogleLogo: React.FC<React.SVGProps<SVGSVGElement>> = ({
  fill,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}
  >
    <title>Google Logo</title>
    <g clipPath="url(#clip0_3180_16524)">
      <path
        d="M9.99988 8.18164V12.0544H15.3817C15.1454 13.2998 14.4362 14.3544 13.3726 15.0635L16.618 17.5817C18.5089 15.8363 19.5998 13.2726 19.5998 10.2272C19.5998 9.51812 19.5362 8.83623 19.418 8.18175L9.99988 8.18164Z"
        fill={fill || "#4285F4"}
      />
      <path
        d="M4.39555 11.9043L3.66358 12.4646L1.07263 14.4828C2.71808 17.7464 6.09056 20.0009 9.99962 20.0009C12.6996 20.0009 14.9632 19.11 16.6177 17.5828L13.3723 15.0646C12.4814 15.6646 11.345 16.0283 9.99962 16.0283C7.39963 16.0283 5.19061 14.2737 4.39964 11.9101L4.39555 11.9043Z"
        fill={fill || "#34A853"}
      />
      <path
        d="M1.07265 5.51758C0.390868 6.86298 0 8.38118 0 9.99933C0 11.6175 0.390868 13.1357 1.07265 14.4811C1.07265 14.4901 4.39998 11.8993 4.39998 11.8993C4.19998 11.2993 4.08177 10.663 4.08177 9.99923C4.08177 9.33551 4.19998 8.69918 4.39998 8.09919L1.07265 5.51758Z"
        fill={fill || "#FBBC05"}
      />
      <path
        d="M9.99982 3.98182C11.4726 3.98182 12.7816 4.49089 13.8271 5.47272L16.6907 2.60912C14.9543 0.990971 12.6999 0 9.99982 0C6.09076 0 2.71808 2.24545 1.07263 5.51819L4.39986 8.10001C5.19072 5.73635 7.39984 3.98182 9.99982 3.98182Z"
        fill={fill || "#EA4335"}
      />
    </g>
    <defs>
      <clipPath id="clip0_3180_16524">
        <rect width="20" height="20" fill={fill || "white"} />
      </clipPath>
    </defs>
  </svg>
);
